export const appVersion = 'master_ca3bc5b';
